import { ALL_USERS_ROLE } from "./constants";

/**
 * Handles selection logic for personas.
 * Ensures "All users" is mutually exclusive with other personas.
 * - Selecting "All users" deselects all other personas.
 * - Deselecting "All users" leaves other personas selected.
 * - Selecting any other persona removes "All users" if present.
 * Note: This function works with personas but stores them in the Roles property for API compatibility.
 */
export function getUpdatedPersonas(selectedPersonas: string[] | undefined, item: string): string[] {
    let updatedPersonas: string[] = [];

    if (item === ALL_USERS_ROLE) {
        if (selectedPersonas?.includes(ALL_USERS_ROLE)) {
            if ((selectedPersonas?.length ?? 0) > 1) {
            updatedPersonas = (selectedPersonas).filter(persona => persona !== ALL_USERS_ROLE);
            }
        }
        else {
            updatedPersonas = [ALL_USERS_ROLE];
        }
    } else {
        if (selectedPersonas?.includes(item)) {
            updatedPersonas = (selectedPersonas).filter(persona => persona !== item);
        } else {
            updatedPersonas = [
                ...(selectedPersonas ?? []).filter(persona => persona !== ALL_USERS_ROLE),
                item
            ];
        }
    }
    return updatedPersonas;
}

/**
 * Determines Encompass Super Administrator status from raw persona strings.
 * Personas containing "TPO" belong to TPO Connect's own persona taxonomy and are
 * excluded, even if they also contain "admin" (e.g. "TPO Administrator").
 */
export function isEncompassAdmin(personas: string[]): boolean {
    return personas.some(persona => {
        const normalized = persona.toLowerCase();
        return normalized.includes('admin') && !normalized.includes('tpo');
    });
}
